import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { CardActionArea, Grid, Stack } from "@mui/material";
import "./style.css";
import { Chip } from "@material-ui/core";
const ProjectDetails = ({ projects }) => {
  // console.log(projects);
  return (
    <Grid item xs={12} md={4} className="box">
      <Card className="card">
        <CardActionArea>
          <CardMedia
            component="img"
            height="100%"
            image={projects.image}
            alt="green iguana"
          />
          <CardContent className="card-content">
            <Typography gutterBottom variant="h5" component="div">
              {projects.Name}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{textAlign:"left"}}>
            {projects.description}
            </Typography>
            <br />

           <div className="tech-container">
           {projects.technology.map((d) => (
              <Stack direction="row" >
              <Chip className="tech" label={d} variant="outlined"/>
            </Stack>
            ))}
           </div>
          
          </CardContent>
        </CardActionArea>
        {/* <div className="border"></div> */}
        <div className="bottom-div">
        <a className="" href={projects.client} target="_blank" rel="noreferrer"><OpenInNewIcon/></a>
           </div>
      </Card>
    </Grid>
  );
};

export default ProjectDetails;
